import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  loaderContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  loader: {
    width: "110px",
    height: "110px",
    position: "relative",
    display: "inline-block",
    borderRadius: "50%",
    background: "conic-gradient(from 0deg, #fff, #0060df)",
    "-webkit-mask":
      "radial-gradient(farthest-side, transparent calc(100% - 8px), #000 0)",
    mask: "radial-gradient(farthest-side, transparent calc(100% - 8px), #000 0)",
    animation: "spin 1s linear infinite",
    "&::before": {
      content: "",
      position: "absolute",
      top: 0,
      right: "calc(50% - 8px / 2)",
      width: "8px",
      height: "8px",
      background: "#fff",
      borderRadius: "50%",
    },
  },
  info: {
    color: "#64748B",
    paddingTop: "20px",
    fontWeight: "500",
  },
}));
